const currencyCodeToSymbolMap = {
  GBP: "£",
  EUR: "€",
  USD: "$",
  BGN: "лв",
  CHF: "CHF",
  CZK: "Kč",
  DKK: "kr",
  HRK: "kn",
  HUF: "ft",
  PLN: "zł",
  RUB: "₽",
  RON: "lei",
  TRY: "₺",
  UAH: "₴",
};

export const currencyCodes = Object.keys(currencyCodeToSymbolMap);

export const currencyCodeToSymbol = code => currencyCodeToSymbolMap[code] || code;

export const formatPayment = ({amount = 0, currency = "GBP", digits = true, isCents = false}) => {
  const formattedAmount = isCents ? amount / 100 : amount;

  return Math.abs(formattedAmount).toLocaleString("en-GB", {
    style: "currency",
    currency,
    minimumFractionDigits: digits ? 2 : 0,
    maximumFractionDigits: 2,
  });
};
